const CustomInput = ({ placeholder, type, value, onChange }) => {
  return (
    <input
      className="h-[45px] w-full text-[13px] rounded-[2px] px-[10px] border border-[#D9D9D9] focus:outline-none focus:ring-0 focus:ring-offset-0 focus:border-[#D9D9D9]"
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
    />
  );
};

export default CustomInput;
